import { useSession } from './use-session';

/** The active workspace of the logged-in person (remembered per person by the API). */
export function useActiveWorkspace(): {
  id: string | null;
  name: string | null;
  workspaces: { id: string; name: string }[];
} {
  const { workspaces, activeWorkspaceId } = useSession();
  const active = workspaces.find((w) => w.id === activeWorkspaceId) ?? null;
  return { id: active?.id ?? null, name: active?.name ?? null, workspaces };
}
